export default "__VITE_ASSET__Ni8lmUp4__"